import React from "react";
import { Link } from "react-router-dom";
import styles from "./ModuleMenu.module.css";

export const ModuleCard = ({ module, progress: progressData }) => {
  const progressValue = progressData?.progress || 0;
  const isComplete = progressValue >= 100;
  const stepCount = module.stepCount || 0;
  const stepsDone = stepCount
    ? Math.round((progressValue / 100) * stepCount)
    : 0;

  /* No module number: the zero-padded 01 / 02 / 03 sequence is the exact
     pattern design.md §14a names. The step count is the only part of the old
     kicker that told you something before you clicked. */
  const kickerBits = [];
  if (stepCount) kickerBits.push(`${stepCount} step${stepCount === 1 ? "" : "s"}`);

  return (
    <Link
      to={`/art-of-looking/${module.slug.current}`}
      className={styles.tile}
    >
      <div className={styles.tileKicker}>
        {kickerBits.map((bit, i) => (
          <React.Fragment key={i}>
            {i > 0 && <span className={styles.tileKickerDot}>·</span>}
            <span>{bit}</span>
          </React.Fragment>
        ))}
      </div>
      <h3 className={styles.cardHeader}>{module.title}</h3>
      <p className={styles.cardDescription}>{module.description}</p>

      {/* No status icon: the pearl row below already encodes both progress and
          completion, so an icon beside it was a third restatement of the same
          fact — and it was FontAwesome, which §14d rules out. */}
      <div className={styles.progressContainer}>
        {stepCount > 0 ? (
          <div className={styles.pearls} aria-label={`${stepsDone} of ${stepCount} steps complete`}>
            {Array.from({ length: stepCount }).map((_, i) => {
              const done = i < stepsDone;
              const current = !isComplete && i === stepsDone;
              return (
                <span
                  key={i}
                  className={`${styles.pearl} ${
                    done ? styles.pearlDone : ""
                  } ${current ? styles.pearlCurrent : ""}`}
                />
              );
            })}
          </div>
        ) : (
          <div className={styles.progressBarFallback}>
            <div
              className={styles.progressBarFill}
              style={{ width: `${progressValue}%` }}
            />
          </div>
        )}
      </div>
    </Link>
  );
};
